import React from 'react';
import AboutHero from '../components/AboutHero/AboutHero';
import MissionSection from '../components/MissionSection/MissionSection';
import './AboutSystem.css';

const AboutSystem = () => {
  return (
    <div className="about-system">
      <AboutHero />
      <MissionSection />
    </div>
  );
};

export default AboutSystem; 